import { useState } from 'react';
import { AccountCacheService } from '../../../services/accountService';
import ComboBox from '../ComboBox';
import TextBox from '../TextBox/TextBox';
import GridView from '../GridView/GridView';
import { Result } from '../../../models/interfaces';
import { MdAdd } from 'react-icons/md';

type periodLimit = {
	id: number,
	name: string
}

function getPeriodLimits(): periodLimit[] {
	return [
		{ id: 1, name: "Daily" },
		{ id: 2, name: "Weekly" },
		{ id: 3, name: "Monthly" }
	]
}

export type TransactionLimitData = {
	transactionType?: string,
	amount?: number,
	period?: number,
}

export interface TransactionLimitProps<T> {
	onSaveChanges?: (limit: TransactionLimitData) => Promise<T | null | undefined>;
	onDeleteLimit?: (limit: T, limits: T[]) => Promise<T[] | undefined>;

	onGetTransactionLimits: () => Promise<Result<T[]> | undefined>
	hideColumns?: string[];
	displayTitle?: () => JSX.Element;
	dataFormatters?: ((column: string, record: T) => JSX.Element)[]
}

function TransactionLimit<T>(props: TransactionLimitProps<T>) {
	const accountCacheService = new AccountCacheService();

	const [transactionLimit, setTransactionLimit] = useState<TransactionLimitData>({});
	const [limits, setLimits] = useState<T[]>([]);

	const getTransactionsLimits = async () => {
		const resp = await props.onGetTransactionLimits?.();
		setLimits(resp?.data ?? []);
		return resp;
	}

	getTransactionsLimits()

	return (
		<div className='row'>
			<div className="col">
				{props.displayTitle?.()}
				<div className="row">
					<div className="col">
						<ComboBox id='transactionTypes'
							text='Transaction Types'
							prompt='Select Transaction Type(s)'
							items={accountCacheService.getTransationTypes().map(d => {
								const item = { id: d.id, name: d.name }
								return item;
							})}
							value={transactionLimit?.transactionType ?? 0}
							onChange={(e) => {
								setTransactionLimit({ ...transactionLimit, transactionType: e.currentTarget.value });
							}} />
					</div>
					<div className="col">
						<ComboBox id='periodType' text='Period' prompt='Select Period'
							value={transactionLimit?.period}
							items={getPeriodLimits().map(d => { return { id: d.id, name: d.name } })}
							onChange={(e) => {
								setTransactionLimit({ ...transactionLimit, period: Number(e.currentTarget.value) })
							}} />
					</div>
				</div>

				<TextBox
					id='amount'
					text='Amount'
					type='number'
					minValue={0}
					value={transactionLimit?.amount}
					onChange={(e) => {
						setTransactionLimit({ ...transactionLimit, amount: e.currentTarget.valueAsNumber })
					}} />

				<hr />
				<div className="form-group">
					<button type='button' id='btnSaveTransactionLimit' className='btn btn-primary btn-sm'
						onClick={() => {
							const saveChanges = async () => {
								const newLimit = await props.onSaveChanges?.(transactionLimit);
								if (newLimit !== undefined) {
									const newLimits = [...limits, newLimit];
									setLimits(newLimits);
								}
							}

							saveChanges();
						}}>
						<MdAdd />
						Add Limit
					</button>
				</div>

				<div style={{ marginTop: "20px", maxHeight: "20em", overflow: "auto", marginBottom: "1em" }}>
					<GridView>
						recordType='Transaction Limit'
						hideColumns={[...props.hideColumns ?? [], "dateModified", "modifiedBy"]}
						name='transactionLimitList'
						displayContextMenu={true}
						menuItems={[{
							name: "Delete Limit",
							contextName: "Limit",
							onClick: (limit) => {
								const removeLimit = async () => {
									const newLimits = await props.onDeleteLimit?.(limit, limits);
									if (newLimits !== undefined) {
										setLimits(newLimits as T[]);
									}
								}

								removeLimit();
							},
						}]}
						rowsPerPage={50}
					</GridView>
				</div>
			</div>
		</div>
	);
}

export default TransactionLimit;